<template>
  <div class="home">
    <van-nav-bar
      :title="$t('platform.platformSearch')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.go(-1)"
    >
	<!-- $router.push('/PlatformList') -->
    </van-nav-bar>
    <div class="shopList">
      <van-sticky :offset-top="46">
        <van-search
          v-model="value"
          show-action
          fixed
          z-index="9"
          shape="round"
          placeholder="请输入搜索门店id"
          @search="onSearch"
        >
          <!-- <template #left>
						<van-icon name="sort" @click="onSearch"/>
					</template> -->
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </van-sticky>

      <template v-for="(shop, index) in shops">
        <van-cell center :title="shop.name">
          <template #icon>
            <van-icon :name="shop.image" size="65" style="margin-right: 10px" />
          </template>
          <template slot="right-icon">
            <div class="tagSort">
              <van-icon
                v-if="!shop.isbind"
                @click="addBind(shop.store_id, index)"
                size="25px"
                name="./static/img/add_Dishes.png"
              />
              <span v-else>已添加</span>
              <!-- <van-icon @click="sortTagUp(index)" size="25px" name="./static/img/up.png" /> -->
              <!-- <van-icon name="arrow" size="25px" @click="$router.push('/TagMenu/'+shop.id)"/>    -->
            </div>
          </template>
        </van-cell>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      shops: [],
    };
  },
  mounted: function () {},
  computed: {},
  methods: {
    onSearch() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/store/search",
        data: {
          id: this.value,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.shops = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
    addBind(id, index) {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/promo/store",
        data: {
          store_id:Number(sessionStorage.getItem('actShopId')) ,
		  promo_id:id,
        //   type: "add", // 类型：【add：添加，reduce：减少、删除】
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: "绑定成功",
            });
            this.$set(this.shops[index], "isbind", true);
            // this.shops=res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
  },
};
</script>
<style>
.addShop .van-grid-item__content {
  padding: 0;
}
.addShop .van-image {
  margin: auto;
}
</style>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
.home {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}
.shopList {
  /*padding-top: 53px;*/
  padding-top: 46px;
}
.tagSort {
  /*width: 86px;*/
  width: 50px;
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/Platform/PlatformBind.vue